module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp1_8017.efaac65f.png";